import 'vscode/vscode/vs/platform/instantiation/common/instantiation';

class BrowserElevatedFileService {
    isSupported(resource) {
        return false;
    }
    async writeFileElevated(resource, value, options) {
        throw ( new Error('Unsupported'));
    }
}

export { BrowserElevatedFileService };
